import React, { useEffect, useState } from "react";
import {
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@material-ui/core";

import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import ContentEditor from "./ContentEditor";

import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";
import { DateInput, Select, TextInput } from "../../components/Form";

const GET_COURSE = gql`
  query course($id: Int!) {
    course(id: $id) {
      id
      name
      dateStart
      dateEnd
      contents {
        type
        body
      }
    }
  }
`;

const GET_EVENT = gql`
  query event($id: Int!) {
    event(id: $id) {
      id
      name
      dateStart
      dateEnd
      contents {
        type
        body
      }
    }
  }
`;

const SAVE_COURSE = gql`
  mutation saveCourse($courseInput: CourseInput!) {
    saveCourse(courseInput: $courseInput)
  }
`;

const SAVE_EVENT = gql`
  mutation saveEvent($eventInput: EventInput!) {
    saveEvent(eventInput: $eventInput)
  }
`;
export default function EventForm({ open, data, onClose = () => {} }) {
  const Alert = useAlert();
  const [title, setTitle] = useState("");
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [contents, setContents] = useState({
    contents: [],
  });

  const [getCourse, { loading: getCourseLoading }] = useLazyQuery(GET_COURSE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ course }) {
      if (course) {
        let newContents = [];
        course.contents.map(({ __typename, ...item }) => {
          newContents.push(item);
        });
        setTitle(course.name);
        setDateStart(course.dateStart);
        setDateEnd(course.dateEnd);
        setContents({ contents: newContents });
      }
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  const [getEvent, { loading: getEventLoading }] = useLazyQuery(GET_EVENT, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ event }) {
      if (event) {
        let newContents = [];
        event.contents.map(({ __typename, ...item }) => {
          newContents.push(item);
        });
        setTitle(event.name);
        setDateStart(event.dateStart);
        setDateEnd(event.dateEnd);
        setContents({ contents: newContents });
      }
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  useEffect(() => {
    if (Boolean(data.id)) {
      if (data.type === "course") getCourse({ variables: { id: data.id } });
      else getEvent({ variables: { id: data.id } });
    } else {
      setTitle("");
      setContents({ contents: [] });
    }
  }, [data]);

  const [saveCourse, { loading: saveCourseLoading }] = useMutation(
    SAVE_COURSE,
    {
      onCompleted({ saveCourse }) {
        if (saveCourse) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: onClose("refetch"),
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );

  const [saveEvent, { loading: saveEventLoading }] = useMutation(SAVE_EVENT, {
    onCompleted({ saveEvent }) {
      if (saveEvent) {
        Alert.alert("", "儲存成功", [
          {
            text: "確定",
            onPress: onClose("refetch"),
            type: "ok",
          },
        ]);
      } else {
        Alert.alert("", "儲存失敗，請再次嘗試。", [
          { text: "確定", type: "ok" },
        ]);
      }
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  function save() {
    const detailsNull = contents.contents.find(
      (item) =>
        (item.type === "HEADING" && item.body === "") ||
        (item.type === "PARAGRAPH" && item.body === "") ||
        (item.type === "IMAGE" && item.body === "") ||
        (item.type === "VIDEO" && item.body === "")
    );

    if (!Boolean(title)) {
      return Alert.alert("", "標題未填寫！", [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    }

    if (detailsNull) {
      return Alert.alert(
        "",
        `${data.type === "course" ? "課程" : "活動"}內容未填寫完！`,
        [
          {
            text: "確定",
            type: "ok",
          },
        ]
      );
    }
    if (data.type === "course") {
      let courseInput = {
        name: title,
        dateStart,
        dateEnd,
        contents: contents.contents,
      };
      if (Boolean(data.id)) {
        courseInput.id = data.id;
      }
      saveCourse({
        variables: {
          courseInput,
        },
      });
    } else {
      let eventInput = {
        name: title,
        dateStart,
        dateEnd,
        contents: contents.contents,
      };
      if (Boolean(data.id)) {
        eventInput.id = data.id;
      }
      saveEvent({
        variables: {
          eventInput,
        },
      });
    }
  }

  if (false) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
        <LoadingModal
          loading={
            saveCourseLoading ||
            saveEventLoading ||
            getEventLoading ||
            getCourseLoading
          }
        />
        <DialogTitle align="center">{`${
          data.type === "course" ? "課程" : "活動"
        }時間`}</DialogTitle>
        <DialogContent style={{ overflowY: 0 }}>
          <Grid container spacing={1}>
            <Grid item sm={4} xs={4}>
              <TextInput
                value={title}
                onChange={(v) => setTitle(v)}
                label="標題"
                fullWidth
              />
            </Grid>
            <Grid item sm={4} xs={4}>
              <DateInput
                label="開始日期"
                format={"yyyy-MM-dd"}
                value={dateStart}
                onChange={(v) => setDateStart(v)}
                fullWidth
              />
            </Grid>
            <Grid item sm={4} xs={4}>
              <DateInput
                label="結束日期"
                format={"yyyy-MM-dd"}
                value={dateEnd}
                onChange={(v) => setDateEnd(v)}
                fullWidth
              />
            </Grid>
            {"\u2002"}
          </Grid>
        </DialogContent>
        <DialogContent style={{ overflowY: 0 }}>
          <ContentEditor
            data={contents}
            onChangeData={(e) => setContents({ contents: e })}
          />
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1} justify="center">
            <Grid item>
              <Button variant="contained" color="primary" onClick={save}>
                儲存
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={onClose}>
                返回
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}
